import { THREE_AXIS_WIDGETS_TYPES } from './consts';

export const FORMAT_POINT_BY_WIDGET_TYPE = {
    [THREE_AXIS_WIDGETS_TYPES.Variwide]: (x, y, z) => [x, y, z],
    [THREE_AXIS_WIDGETS_TYPES.Bubble]: (x, y, z, name) => ({ x, y, z, name }),
};
